<template>
  <div style="white-space: nowrap">
    <slot>{{ competition.code }}</slot>
    <AppShowCompetitionTagsGroup :competition="competition" />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
import AppShowCompetitionTagsGroup from "./AppShowCompetitionTagsGroup.vue";

export default defineComponent({
  name: "AppShowCompetitionCodeAndTags",
  components: { AppShowCompetitionTagsGroup },
  props: {
    competition: {
      type: Object,
      required: true
    }
  },
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        code
        isHighlighted
        isGrandPrix
        displayChips
        ${AppShowCompetitionTagsGroup.fragments.competitionFields}
      }
    `
  }
});
</script>
